<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { useTemplateRef } from "vue";
import { cn } from "@/utils/shadcn"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()

const elRef = useTemplateRef('el');

defineExpose({
  el: elRef,
});
</script>

<template>
  <div
    data-slot="dialog-header"
    :class="cn('flex flex-col gap-2 text-center sm:text-left', props.class)"
    ref="el"
  >
    <slot></slot>
  </div>
</template>
